<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 21 18" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.2797 2.68143H0.777954V0.681427H20.2797V2.68143Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.2797 17.6222H0.777954V15.6222H20.2797V17.6222Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0387 10.1518H0.777954V8.15176H15.0387V10.1518Z" fill="currentColor"/>
    </svg>
</template>